// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__HHBeu","title":"ClientCherryInfo_title__3mtH0","itemText":"ClientCherryInfo_itemText__2NcCN"};